/// <amd-module name="Wit/Common/CurrentDirectoryService/ICurrentDirectoryService" />
import { WebApiTeam } from "Tfs/Platform/Contracts/Core";
import { getTFSPageData } from "Tfs/Platform/Page";
import { IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { onClickFPS } from "VSS/Platform/FPS";
import { routeUrl } from "VSS/Platform/Location";
import { DirectoryItem } from "Wit/DirectoryService/Client/Contracts/Directory";

const CurrentTeamDataProvider = "ms.vss-tfs-web.team-context-data-provider";
const WorkItemsFormRoute = "ms.vss-work-web.work-items-form-route";

export interface ICurrentDirectoryService extends IVssService {
    getCurrentDirectory: () => IReadonlyObservableValue<DirectoryItem | undefined>;
    setCurrentDirectory: (directory: DirectoryItem | undefined) => void;
    getWorkItemsFormUrl(workItemId: number): string;
}

export class CurrentDirectoryService extends VssService implements ICurrentDirectoryService {
    private currentDirectory = new ObservableValue<DirectoryItem | undefined>(undefined);

    public _serviceStart = (pageContext: IVssPageContext): void => {
        super._serviceStart(pageContext);

        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const currentTeam = contributionService.getData<WebApiTeam | undefined>(CurrentTeamDataProvider);
        if (currentTeam && currentTeam.name) {
            this.currentDirectory.value = { id: currentTeam.id, name: currentTeam.name, url: "" } as DirectoryItem;
        }
    };

    public _serviceEnd = (pageContext: IVssPageContext): void => {
        super._serviceEnd(pageContext);
    };

    public getCurrentDirectory = (): IReadonlyObservableValue<DirectoryItem | undefined> => {
        return this.currentDirectory;
    };

    public setCurrentDirectory = (directory: DirectoryItem | undefined) => {
        this.currentDirectory.value = directory;

        // seems like we always want to update route, so do so here.
        directory?.url && onClickFPS(this.pageContext, directory.url, true);
    };

    public getWorkItemsFormUrl(workItemId: number): string {
        const routeValues: { [key: string]: string } = this.getDefaultRouteValues();
        routeValues["teamName"] = this.getCurrentDirectory().value?.name || "";
        routeValues["id"] = workItemId.toString();
        return routeUrl(this.pageContext, WorkItemsFormRoute, routeValues);
    }

    public getDefaultRouteValues(): { [key: string]: string } {
        const routeValues: { [key: string]: string } = {};
        const projectName = getTFSPageData(this.pageContext)?.project?.name;
        routeValues["project"] = projectName || "";

        return routeValues;
    }
}

Services.add("ICurrentDirectoryService", { serviceFactory: CurrentDirectoryService });
